import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Star } from "lucide-react";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <section className="bg-[#050505] py-24 md:py-32 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16">
          <div className="flex items-center gap-3 mb-4">
            <span className="h-px w-12 bg-[#FF3333]" />
            <span className="text-xs tracking-[0.3em] uppercase font-bold text-[#FF3333]">05 — Word on the Street</span>
          </div>
          <h2 className="font-display font-black uppercase text-5xl md:text-7xl tracking-tighter leading-none">
            What clients <span className="italic text-[#FF3333]">say</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {items.map((t, idx) => (
            <div
              key={t.id}
              data-testid={`testimonial-${t.id}`}
              className="border border-white/10 p-8 md:p-10 hover:border-[#FF3333]/40 transition-colors bg-[#0C0C0C]"
            >
              <div className="flex gap-1 mb-5">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-[#FF3333] text-[#FF3333]" />
                ))}
              </div>
              <p className="text-white/80 font-light text-lg leading-relaxed mb-6">"{t.text}"</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-[#FF3333] text-black font-display font-black flex items-center justify-center">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="font-bold text-white">{t.name}</div>
                  <div className="text-xs uppercase tracking-[0.2em] text-white/40">Verified Client</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
